import styled from "styled-components";
import { Box as MuiBox, Typography as MuiTypography } from "@mui/material";

export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    width: calc(1920px - 256px - 96px);
  }
  outline: none;
`;

export const Container = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Box = styled(MuiBox)`
  &.MuiBox-root {
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }
  // & .MuiButtonBase-root {
  //   color: #79747e;
  // }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const SecondContainer = styled(MuiBox)`
  &.MuiBox-root {
    padding-top: 10px;
    width: 58%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }
`;

export const SecondBox = styled(MuiBox)`
  &.MuiBox-root {
    height: 60px;
    display: flex;
    gap: 2px;
    margin-left: 10px;
  }
  // & .MuiButtonBase-root {
  //   color: #79747e;
  // }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const ThirdBox = styled(MuiBox)`
  &.MuiBox-root {
    height: 20px;
    display: flex;
    margin-left: 10px;
    gap: 2px;
  }
  // & .MuiButtonBase-root {
  //   color: #79747e;
  // }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const Typography = styled(MuiTypography)`
  &.MuiTypography-root {
    flex-direction: column;
    justify-content: flex-start;
    font-size: 12px;
    text-overflow: ellipsis;
  }
`;
